import 'regenerator-runtime/runtime';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getEndpointUrl, GlobalActions, GlobalPut, HTTP_METHOD } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { DashboardAction, DashboardActions } from '../dashboard.actions';
import { environment } from '../../environments/environment';
import { IAppState } from '../appState';
import { FileToDeletePayload } from './payloads/fileToDeletePayload';

export const FILE_DELETION_URL = '/privatschutz/api/sds/';
const dashboardActions = new DashboardActions();

export enum FILE_DELETION_EVENTS {
  FILE_DELETION_SUCCESSFUL_EVENT = 'FILE_DELETION_SUCCESSFUL_EVENT',
  FILE_DELETION_FAILED_EVENT = 'FILE_DELETION_FAILED_EVENT',
}

export function* watchFileDeleted() {
  yield takeEvery(
    DashboardActions.FILE_DELETION_REQUESTED,
    safeSaga(fileDeletionSaga, App.SHOP_DASHBOARD),
  );
}


export function* fileDeletionSaga(action: DashboardAction<FileToDeletePayload>) {
  const globalPut = GlobalPut.getInstance();
  const { documentId, fileUploaderId, angebotsId } = action.payload;
  const state: IAppState = yield select();
  const apigeeActiveAndPerma =
    environment.apigeeActive && state.transientState.permasession;
  yield put({
    type: DashboardActions.FILE_MODIFICATION_IN_PROGRESS,
  });
  yield call(
    globalPut.put,
    new GlobalActions().doRequest({
      appId: App.SHOP_DASHBOARD,
      url: getEndpointUrl(apigeeActiveAndPerma, FILE_DELETION_URL + documentId + '/delete'),
      method: HTTP_METHOD.POST,
      successEvent: FILE_DELETION_EVENTS.FILE_DELETION_SUCCESSFUL_EVENT,
      errorEvent: FILE_DELETION_EVENTS.FILE_DELETION_FAILED_EVENT,
      additionalData: {
        fileUploaderId,
        angebotsId,
      },
      retry: {
        times: 3,
        delay: 100,
      },
    }),
  );
  const appId = state?.warenkorb?.find(p => p.angebotsId === angebotsId)?.appId ?? App.VWG;
  yield put(dashboardActions.elementarFragebogenfilesDeleted(documentId, angebotsId, appId));
  yield put(dashboardActions.fileModificationFinished());
}
